import { Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { indexComponent } from './component/index/index.component';

import { imageBatchComponent } from './component/imageBatch/imageBatchComponent';
import { historyListComponent } from './component/historyList/historyList.component';
import { shoppingOrderComponent } from './component/shoppingOrder/shoppingOrder';
import { containerNumberComponent } from './component/containerNumber/containerNumber';
import { sealNumberComponent } from './component/sealNumber/sealNumber';
import { identificationViewComponent } from './component/identificationView/identification';
import { zhuangxiangdanComponent } from './component/identificationView/component/zhuangxiangdan/zhuangxiangdan';
import { identificationComponent } from './component/identification/identification';
import { identificationNewComponent } from './component/identificationNew/identification';
import { customsDeclarationsComponent } from './component/customsDeclarations/customsDeclarations'

@Component({
  selector: 'fountain-root',
  template: '<router-outlet></router-outlet>'
})
export class RootComponent { }

export const routes: Routes = [
  {
    path: '',
    component: indexComponent,
  },
  {
    path: 'imgUpdata/:id',
    component: imageBatchComponent,
  },
  {
    path: 'index',
    component: indexComponent,
  },
  {
    path: 'historyList',
    component: historyListComponent,
  },
  {
    path: 'shoppingOrder/:id',
    component: shoppingOrderComponent,
  },
  {
    path: 'containerNumber/:id',
    component: containerNumberComponent,
  },
  {
    path: 'sealNumber/:id',
    component: sealNumberComponent,
  },
  {
    path:'identificationView',
    component:identificationViewComponent,
    children:[
      {
        path:'zhuangxiangdan',
        component:zhuangxiangdanComponent
      }
    ]
  },
  {
    path:'identification/:orderNo/:token',
    component:identificationComponent
  },
  {
    path:'identificationNew/:orderNo/:token',
    component:identificationNewComponent
  },
  {
    path: 'customsDeclarations/:orderNo',
    component:customsDeclarationsComponent
  }
  


   



];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/route.ts